module.exports = __webpack_public_path__ + "static/media/strideQ-logo.cc0c9de3.png";